// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"a2a9591c","311":"c5398e79","856":"f8f8d0e2"}[chunkId] + ".chunk.js";
};